import { TrustPilot } from '../TrustMarkerWidgets'

const Testimonials = ({
  city = 'California',
  testimonials = [],
  rating = 4.6,
  outOf = 5,
  totalReview = 46532,
  type = 'trustpilot',
  link = 'https://www.trustpilot.com/review/freedomdebtrelief.com',
}) => {
  return (
    <div className="my-8 bg-[#FAFAFA] p-4 lg:px-6 lg:py-8">
      <h2 className="my-4! text-black-base! lg:my-8! text-center text-heading-3 font-medium leading-heading-3">
        Reviews and Testimonials from {city}
      </h2>
      {testimonials.length > 0 && (
        <div className="justify-between gap-8 lg:flex">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="mb-4 shrink-0 grow-0 basis-[30%] flex-col lg:mb-0 lg:flex"
            >
              <p className="lg:line-clamp-8 mb-1 flex-[1_1_0%] text-12 leading-[18px]">
                {testimonial.text}
              </p>
              <p className="text-14 leading-5 text-neutral-300">
                {testimonial.consumer.name}, {testimonial.consumer.country}
              </p>
              {type === 'trustpilot' && (
                <TrustPilot
                  showOnlyStars
                  rating={testimonial.stars}
                  color="#33b083"
                  starSize={20}
                  align="left"
                />
              )}
            </div>
          ))}
        </div>
      )}
      <div className="mt-8 text-center text-14">
        Rated <b>{Number(rating)}</b>/{outOf} based on{' '}
        <a
          className="text-black-base hover:underline"
          href={link}
          target="_blank"
        >
          {totalReview}+ reviews
        </a>
      </div>
    </div>
  )
}

export default Testimonials
